export default "__VITE_ASSET__f36S0sgp__"